/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TrophyIcon = ({ width = 24, height = 24, hidden = false, title = 'Trophy' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M24.213 18.021a15.517 15.517 0 0 0 11.35-12.876A1 1 0 0 0 34.571 4h-6.706c.089-1.3.135-2.634.135-4H8c0 1.366.046 2.7.135 4H1.429a.993.993 0 0 0-.991 1.145 15.514 15.514 0 0 0 11.349 12.876A9.169 9.169 0 0 0 16 22v8c-3.144.82-5.866 2.849-6.682 6h17.364c-.816-3.151-3.538-5.18-6.682-6v-8a9.169 9.169 0 0 0 4.213-3.979ZM33.4 6c-.839 2.9-2.582 7.347-7.945 9.526A35.182 35.182 0 0 0 27.688 6ZM2.6 6h5.712a35.175 35.175 0 0 0 2.234 9.525C5.182 13.346 3.439 8.9 2.6 6Z"
    />
  </svg>`;
};
